/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SubscriptionData } from './SubscriptionData';
import {
    instanceOfSubscriptionData,
    SubscriptionDataFromJSON,
    SubscriptionDataFromJSONTyped,
    SubscriptionDataToJSON,
} from './SubscriptionData';

/**
 * @type ProjectDataSubscription
 * 
 * @export
 */
export type ProjectDataSubscription = SubscriptionData;

export function ProjectDataSubscriptionFromJSON(json: any): ProjectDataSubscription {
    return ProjectDataSubscriptionFromJSONTyped(json, false);
}

export function ProjectDataSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDataSubscription {
    if (json == null) {
        return json;
    }
    if (instanceOfSubscriptionData(json)) {
        return SubscriptionDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function ProjectDataSubscriptionToJSON(json: any): any {
    return ProjectDataSubscriptionToJSONTyped(json, false);
}

export function ProjectDataSubscriptionToJSONTyped(value?: ProjectDataSubscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfSubscriptionData(value)) {
        return SubscriptionDataToJSON(value as SubscriptionData);
    }

    return {};
}

